/* eslint-disable no-undef */

import api from '@/api/index'

export const GET_PERIODS = 'GET_PERIODS'

export default {
  state: {
    periodNameList: [],
    banners: [{
      imgUrl: 'https://img.qzhlkj.net/2020.jpg'
    }]
  },
  mutations: {
    [GET_PERIODS](state, periods) {
      Object.assign(state, periods)
    }
  },
  actions: {
    [GET_PERIODS]({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.findPeriodPlanAndNameAndOrderByCompanyId().then((data) => {
          commit(GET_PERIODS, data.data)
          resolve(data.data)
        }, (err) => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/periods.js